import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconVideo: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconVideo"><Path fillRule="evenodd" clipRule="evenodd" d="M2 4H16V8.38184L22 5.38184V18.6179L16 15.6179V20H2V4ZM16 13.3818L20 15.3818V8.6179L16 10.6179V13.3818Z" fill="currentColor"/></CentralIconBase>;
});

export default IconVideo;
